module.exports = __webpack_public_path__ + "img/client6.87e0e45e.png";